<template>
  <div class="top-spacer"></div>
  <div class="news-detail">
    <div class="container">
      <div class="back-btn">
        <a href="javascript:history.back()">← 返回</a>
      </div>
      <div class="cover" v-if="article.cover">
        <img :src="article.cover" :alt="article.title">
      </div>
      <h1 class="title">{{ article.title }}</h1>
      <time class="publish-time">{{ formatDate(article.date) }}</time>
      <div class="content">
        <p v-for="(paragraph, index) in article.content.split('\n')" :key="index">
          {{ paragraph }}
        </p>
      </div>
      <h1 class="title">规格参数：</h1>
      <Table />
      <h1 class="title">产品竞争优势：</h1>
      <img style="width:100%" src="@/images/u330.png" alt="">
      <h1 class="title">用户评价：</h1>
      <ul>
        <li>引入这台验货机后，我们验货速度变快多了</li>
<li>这款验货机的条码扫描非常精准，几乎没有误读的情况。</li>
<li>界面设计很直观，新员工也能快速上手   </li>
<li>批量扫码功能非常实用，识别区域很大，还可以多层扫码</li>
<li>运行速度很快，连续工作8小时也没有卡顿</li>
<li>与我们的WMS系统无缝对接，数据同步非常方便</li>
<li>定期提供软件升级，功能越来越强大</li>
<li>技术支持团队非常专业，耐心解答我们的问题，售前售后服务也很到位，有问题立刻就解决了</li>
      </ul>
      <img style="width:100%" src="@/images/u333.png" alt="">
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Table from '@/components/Table/desktopRedcodeTable.vue'

const article = ref({
  id: 1,
  title: '桌面读码设备',
  date: '2025-06-29',
  cover: require("@/images/u43.png"), 
  content: `桌面读码设备是将设备放置于台面上，通过批量扫码来解放双手，扫描速度快，最多可扫码100个，提升了效率且该校验机分辦率大，识别区域宽，扫描高度高达1m。桌面读码设备可对接WMS、ERP等软件，也可使用焦点输出方式免对接使用，WES对扫码结果可以自动去重，并且设备会对拍下的照片留底，方便查询追踪。`
})

function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

defineExpose({ formatDate })
</script>

<style scoped>
.top-spacer {
  height: 80px;
  width: 100%;
}

.news-detail {
  background-color: #f8f9fa;
  padding: 40px 20px;
  min-height: 100vh;
  font-family: 'Segoe UI', sans-serif;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 30px;
}

.back-btn {
  margin-bottom: 20px;
}

.back-btn a {
  text-decoration: none;
  color: #007bff;
  font-size: 14px;
}

.cover {
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 20px;
}

.cover img {
  width: 100%;
  height: auto;
  display: block;
}

.title {
  font-size: 28px;
  margin-bottom: 10px;
  color: #333;
}

.publish-time {
  display: block;
  color: #777;
  margin-bottom: 20px;
  font-size: 14px;
}

.content {
  line-height: 1.8;
  font-size: 16px;
  color: #555;
}

.content p {
  margin-bottom: 1em;
}
</style>